<i18n lang='yml' src='../i18n/BookingPayment.yml'></i18n>
<template>
  <div v-if="active">
    <div class='row border-bottom'>
      <div class="col-sm-12 mb-4">
        <h5 class="heading-page">
          {{$t('details')}} 
        </h5>
        <p>
          {{`${details.training_program_full_name} - ${details.exam_type_name[locale]}`}}
        </p>
        <div class="col-sm-12 col-md-12 col-lg-10 col-xl-9">
          <p> {{$t('details_guiding_text')}}</p>
          <ul class="booking-details-list">
            <li class="row">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('exam_challenger')}}
              </span>
              <span class="col-xs-12 col-md-6">{{details.user_name}}</span> 
            </li>
            <li class="row">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('exam')}}
              </span>
              <span class="col-xs-12 col-md-6">{{details.training_program_full_name}} - {{details.exam_type_name[locale]}}</span> 
            </li>

            <li class="row" v-if="details.accommodations && details.accommodations.accommodation_types.length > 0">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('accommodation_requests')}}
              </span>
              <span class="col-xs-12 col-md-6">
                <ul class="p-0">
                  <li v-for="accommodation in details.accommodations.accommodation_types" :key="accommodation">
                    {{$t(`accommodations.${accommodation}`)}}
                  </li>
                </ul>
              </span>
            </li>

            <li class="row">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('exam_location')}}
              </span>
              <span class="col-xs-12 col-md-6">{{details.sittings[0].sub_location.name[locale]}}</span> 
            </li>  
            <li class="row">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('exam_location_address')}}
              </span>
              <span class="col-xs-12 col-md-6">
                {{[details.sittings[0].sub_location.street_address, details.sittings[0].sub_location.city, details.sittings[0].sub_location.province, details.sittings[0].sub_location.postal_code].join(', ')}}
              </span> 
            </li>
            <li class="row">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('exam_date')}}
              </span>
              <span class="col-xs-12 col-md-6">{{bookingDates}}</span> 
            </li>
            <li class="row">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('exam_time')}}
              </span>
              <span class="col-xs-12 col-md-6">{{bookingStartTimes}}</span> 
            </li>
            <li class="row">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('fee_amount')}}
              </span>
              <span class="col-xs-12 col-md-6">{{paymentAmount}}</span> 
            </li>
            <li class="row">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('available_credit')}}
              </span>
              <span class="col-xs-12 col-md-6">{{availableCredit ? $t('yes') : $t('no')}}</span> 
            </li>
            <li class="row mb-4">
              <span class="status-bold col-xs-12 col-md-4">
                {{$t('payment_method')}}
              </span>
              <span class="col-xs-12 col-md-6">  {{$t(paymentByCreditCard ? 'credit_card' : 'apply_credit')}}</span> 
            </li>
            <form v-if="!loading" class="form-inline" :action="paymentPageUrl" method="post">
              <input type='hidden' name="x_login" :value="paymentPageLogin">
              <input type='hidden' name="x_fp_hash" :value="hash">
              <input type='hidden' name="x_fp_sequence" :value="sequence">
              <input type='hidden' name="x_fp_timestamp" :value="timestamp">
              <input type='hidden' name="x_amount" :value="paymentAmount">
              <input type='hidden' name="x_description" :value="bookingNeededDetails">
              <input type='hidden' name="x_show_form" value="PAYMENT_FORM">
              <button v-if="paymentByCreditCard" class='btn btn-sm btn-success' type="submit">{{$t('book_now')}}</button>
              <button v-else :disabled="!availableCredit" class='btn btn-sm btn-success' @click.prevent="nextStep()">{{$t('book_now')}}</button>
            </form>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sendAjaxRequest } from '../../../shared/typescripts/ajax.ts';

import {formatDate, formatTime} from '../../../shared/typescripts/dates.ts'
export default {
  props: ['locale', 'admin', 'base_path', 'paymentPageUrl', 'paymentPageTransactionKey', 'paymentPageLogin', 'details', 'availableCredit', 'active', 'time_format_en', 'time_format_fr'],
  computed: {
    bookingStartTimes: function() {
      return this.details.sittings.map((sitting) => {return this.formatTime(sitting.start_time)}).join(', ')
    },
    bookingDates: function() {
      return this.details.sittings.map((sitting) => {return this.formatDate(sitting.date)}).join(', ')
    },
    bookingNeededDetails: function() {
      try {
        return JSON.stringify({
          exam_type_id: this.details.exam_type_id,
          training_program_id: this.details.training_program_id,
          user_identity_id: this.details.user_identity_id,
          language: this.details.language,
          accommodations: this.details.accommodations,
          booking_dates_attributes: this.details.booking_dates_attributes
        })
      }
      catch {
        console.log("Error in format")
      }
    },
    paymentByCreditCard: function() {
      //TODO CHANGE THIS BACK TO FALSE JUST FOR TESTING
      return this.admin == 'false' && !this.availableCredit;
    }
  },
  watch: {
    active(newVal) {
      if(newVal) {
        if (this.paymentPageLogin && this.paymentPageTransactionKey) {
          this.generatePaymentData()
          if(this.paymentByCreditCard) {
            this.getFeeData()
          }
          else {
            this.paymentAmount = this.details.exam_fee
          }
        }
      }
    },
  },
  data() {
    return {
      hash: '',
      sequence: 0,
      timestamp: 0,
      paymentAmount: 0,
      loading: false
    }
  },
  methods: {
    generatePaymentData() {
      this.generateSequence()
      this.generateTimestamp()
      this.generateHash()
    },
    generateHash() {
      let hmacsha1 = require('hmacsha1');
      let hashMessage = `${this.paymentPageLogin}^${this.sequence}^${this.timestamp}^${this.details.exam_fee}^`
      const buffer = Buffer.from(hmacsha1(this.paymentPageTransactionKey, hashMessage), 'base64');
      const buffString = buffer.toString('hex');
      this.hash = buffString
    },
    generateSequence() {
		  this.sequence = `${Math.floor(Math.random()*999999)}`
    },
    generateTimestamp() {
      this.timestamp = `${Date.now() / 1000}`
    },
    formatDate(dateString) {
      return formatDate(dateString)
    },
    formatTime: function (date) {
      let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
      return formatTime(date, format)
    },
    getFeeData() {
      this.loading = true

      sendAjaxRequest('GET', `${this.base_path}/fee_details`, 'json', {}, this.ajaxSuccess, this.ajaxError);
    },

    ajaxSuccess() {
      this.paymentAmount = data
      this.loading = false
    },

    ajaxError() {
      this.loading = false;
      alert(this.$t('error_loading'));
    },

    nextStep() {    
      this.$emit('nextStep')
    },
  }

}

</script>

